import { Route } from '@angular/router';
import { OnboardingLayoutComponent } from '@buspro/web/shared';
import { AnonUserGuard } from '@corelabs/ng-auth';
import { AccountSetupSuccessComponent } from './account-setup-success/account-setup-success.component';
import { ActivateTenantComponent } from './activate-tenant/activate-tenant.component';
import { SetupPasswordComponent } from './setup-password/setup-password.component';
import { VerifyEmailChangeComponent } from './verify-email-change/verify-email-change.component';

export const TenantOnboardingRoutes: Route[] = [
  {
    path: 'passport',
    canActivate: [AnonUserGuard],
    component: OnboardingLayoutComponent,
    children: [
      {
        path: 'activate-tenant',
        component: ActivateTenantComponent,
        data: { title: 'Activate your company account' },
      },
      {
        path: 'setup-password',
        component: SetupPasswordComponent,
        data: { title: 'Setup Password' },
      },
      {
        path: 'verify-email-change',
        component: VerifyEmailChangeComponent,
        data: { title: 'Verify Email Change' },
      },
    ],
  },
  {
    path: 'passport/setup-success',
    component: AccountSetupSuccessComponent,
    data: { title: 'Account Ready!' },
  },
];
